import { render } from "./admin-clients.vue?vue&type=template&id=0afa518a"
import script from "./admin-clients.vue?vue&type=script&lang=js"
export * from "./admin-clients.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__